import React, { useContext } from 'react';
import { MyPortfolioCapsuleContentProps } from 'widgets/myPortfolioCapsules/MyPortfolioCapsuleWidgetStrategy';
import { PredictedVolumeCapsuleContent } from 'widgets/liquiditySummary/predictedVolumeCapsule/components/PredictedVolumeCapsuleContent';
import { liquidityStreamedDataSelectors } from 'widgets/liquiditySummary/store/data/streamSlice';
import { useMyPortfolioCapsuleConfigSlice } from 'widgets/myPortfolioCapsules/store/config/configSlice';
import { buildData } from 'widgets/liquiditySummary/predictedVolumeCapsule/components/predictedVolumeCapsuleData';
import AppContext from 'app/AppContext';
import { PredictedVolumeCapsuleConfigState } from 'widgets/liquiditySummary/predictedVolumeCapsule/state/config/PredictedVolumeCapsuleConfigState';

const { useSymbolStreamedData } = liquidityStreamedDataSelectors;

export function PredictedVolumeCapsuleMyPortfolioCapsuleContent(
    props: MyPortfolioCapsuleContentProps
) {
    const { symbol, qty, qtyRemaining } = props;
    const { numberFormat } = useContext(AppContext);

    const { config } =
        useMyPortfolioCapsuleConfigSlice<PredictedVolumeCapsuleConfigState>();
    const { includePredContinuousTrading } = config;

    const streamData = useSymbolStreamedData(symbol, config, qty);
    const data = buildData(
        streamData,
        symbol,
        qty,
        qtyRemaining,
        numberFormat,
        includePredContinuousTrading
    );

    const side = (qty ?? 0) > 0 ? 'B' : 'S';

    return (
        <PredictedVolumeCapsuleContent
            chartData={data}
            cssClasses={'side-' + side}
        />
    );
}
